<h2
  mat-dialog-title
  class="text-secondary title-9 uppercase pl-0 justify-content-center pr-0"
>
  {{ multilingualService?.langMap?.LABEL_MORE_LOGOUT }}
</h2>
<p role="alert" class="text-secondary center title-10 text-w-500 mt-2">
  {{ multilingualService?.langMap?.MESSAGE_CONFIRM_LOGOUT }}
</p>
<mat-dialog-actions align="center" class="no-margin">
  <button
    mat-raised-button
    [mat-dialog-close]="true"
    cdkFocusInitial
    class="primary-button primary-small-button title-11"
  >
    {{ multilingualService.langMap?.LABEL_HOME_YES }}
  </button>
  <button
    mat-stroked-button
    mat-dialog-close
    class="secondary-button small-button title-11"
  >
    {{ multilingualService.langMap?.LABEL_HOME_NO }}
  </button>
</mat-dialog-actions>
